export default { sha: '87cd8de1ec122a51e870599e6624e1971975229d', buildNumber: 'undefined' }
